<template>
    <div>
        <Navbar/>
        <div>
             <router-view/>
        </div>
        <component-modal-questions/>
    </div>
</template>
<script>

import { EventBus } from '../../helpers/eventbus/event-bus.js'
import config from '../../config/env.example'

//Componentes
import Navbar from '../Templates/Views/Navbar'
import Footer from '../Templates/Views/footer'
import userprofile from '../Templates/Views/userprofile'


import initVue from '../../helpers/initVue'

import editnewusers from '../../models/editnewuser'



import componentmodalquestions from '../Templates/Views/modalquestions'

import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    data () { 
      return { 
        n: 20,
        valid:true, 
        dialog3:false,
        dialog4: false,
        identity: null,
        session: false,
        token: null,
        userstorage: {},
        routeroot: false,
        users: new editnewusers(),
        imageName: '',
        imageUrl: '',
        imageFile: '',
        addressempty: false,
        rules: {
                required: value => !!value || 'requerido.'
            }
      }
    },

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),

    mounted(){
        this.getidentity()
        var element = document.getElementById("body");
        this.routeroot = this.$route.path === '/'
        this.routeroot = this.$route.path !== '/'
        //console.log(this.$route.path)
    },
    components:{
        Navbar, userprofile, Footer,
        'component-modal-questions':componentmodalquestions
        
    },
    methods: {
        menushow(){
                document.getElementById("sidebar").style = `
                    transform: translateX(0);
                `
        },
        menuhide(){
                    document.getElementById("sidebar").style = `
                        translateX(-100%);
                    `
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.session)
        },

        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        opendialog3(){
          this.dialog3=true
        },

        opendialog4(){
          this.dialog4 = true
          this.dialog3 = false
        },

        closedialog4(){
            this.dialog4 = false
        },


    }

}

</script>


